import { Injectable } from '@angular/core';
import { Action, State, StateContext } from '@ngxs/store';
import { IAttachmentStateModel } from 'src/app/shared/models/dynamic.model';
import {
  AddAttachments,
  DeleteAttachment,
  DeleteTempAttachment,
  RemoveUnsavedAttachments,
  ResetAtatchmnetCodes,
} from './attachments.action';
import { CrudActions, pageType } from 'src/app/shared/utility/constants';

function attachmentIdsMatch(a: unknown, b: unknown): boolean {
  if (a === b) return true;
  if (a == null || b == null) return false;
  const isIdPrimitive = (v: unknown): v is string | number | bigint =>
    typeof v === 'string' || typeof v === 'number' || typeof v === 'bigint';
  if (isIdPrimitive(a) && isIdPrimitive(b)) {
    return String(a) === String(b);
  }
  return false;
}

@State<IAttachmentStateModel>({
  name: 'attachment',
  defaults: {
    attachmentList: [],
  },
})
@Injectable()
export class AttachmentState {
  @Action(AddAttachments)
  addAttachments(
    ctx: StateContext<IAttachmentStateModel>,
    { payload }: AddAttachments
  ) {
    const state = ctx.getState();
    const updatedAttachmentList = state.attachmentList.map(
      (attachment: any) => {
        if (
          attachment.attachmentId === payload.attachmentId &&
          attachment.id === payload.id
        ) {
          if (attachment.isFromScreen === pageType.commodity) {
            return { ...attachment, isSavedData: payload.isSavedData };
          }
        }
        return attachment;
      }
    );

    const existingAttachmentIndex = updatedAttachmentList.findIndex(
      (attachment: any) =>
        attachment.attachmentId === payload.attachmentId &&
        attachment.id === payload.id &&
        (attachment.isFromScreen === pageType.commodity ||
          attachment.isFromScreen === pageType.hawb ||
          attachment.isFromScreen === pageType.bag)
    );

    if (existingAttachmentIndex === -1) {
      updatedAttachmentList.push(payload);
    }
    const newState = {
      ...state,
      attachmentList: updatedAttachmentList,
    };
    ctx.setState(newState);
  }

  @Action(DeleteAttachment)
  deleteAttachment(
    ctx: StateContext<IAttachmentStateModel>,
    { attachmentId }: DeleteAttachment
  ) {
    const state = ctx.getState();
    const updatedAttachmentList = state.attachmentList.map(
      (attachment: any) => {
        if (attachmentIdsMatch(attachment.id, attachmentId)) {
          return { ...attachment, action: CrudActions.delete };
        }
        return attachment;
      }
    );

    const newState = {
      ...state,
      attachmentList: updatedAttachmentList,
    };
    ctx.setState(newState);
  }

  @Action(DeleteTempAttachment)
  deleteTempAttachment(
    ctx: StateContext<IAttachmentStateModel>,
    { attachmentId }: DeleteTempAttachment
  ) {
    const state = ctx.getState();
    const updatedAttachmentList = state.attachmentList.filter(
      attachment => !attachmentIdsMatch(attachment.id, attachmentId)
    );
    const newState = {
      ...state,
      attachmentList: updatedAttachmentList,
    };
    ctx.setState(newState);
  }

  @Action(RemoveUnsavedAttachments)
  removeUnsavedAttachments(ctx: StateContext<IAttachmentStateModel>) {
    const state = ctx.getState();
    const updatedAttachmentList = state.attachmentList.filter(
      (attachment: any) =>
        attachment.isSavedData ||
        (attachment.isFromScreen !== pageType.commodity && pageType.mawbFlight)
    );

    const newState = {
      ...state,
      attachmentList: updatedAttachmentList,
    };
    ctx.setState(newState);
  }

  @Action(ResetAtatchmnetCodes)
  resetAtatchmentCodes(ctx: StateContext<IAttachmentStateModel>) {
    const state = ctx.getState();
    const newState = {
      ...state,
      attachmentList: [],
    };
    ctx.setState(newState);
  }
}
